import React, { useState, useEffect } from 'react';
import { makeStyles } from '@mui/styles';
import Paper from '@mui/material/Paper';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { findBySerie, findAll } from '../Livro/api-livro';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';

const useStyles = makeStyles(theme => ({
    paper: {
        marginTop: '20px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        // marginTop: theme.spacing(1),
    },
    title: {
        flex: '1 1 100%',
        paddingTop: '20px;'
    },
    submit: {
        // margin: theme.spacing(3, 0, 2),
    }
}));

export default function LivroForm({ tdp, setTdp, saveLivro }) {
    const classes = useStyles();
    const [livros, setLivros] = useState([]);
    const [isLivrosAll, setIsLivrosAll] = useState(false);

    useEffect(() => {
        findBySerie(tdp.turma.serie.codSerie).then((data) => {
            if (data.error) {
                console.log(data.error);
            } else {
                setLivros(data);
            }
        }).catch((err => {
            console.log(err)
        }));

    }, [tdp.turma.serie.codSerie]);


    useEffect(() => {
        if (isLivrosAll) {
            findAll().then((data) => {
                if (data.error) {
                    console.log(data);
                } else {
                    setLivros(data);
                }
            })
        }

    }, [isLivrosAll]);


    const handleSwitchChange = () => event => {
        setIsLivrosAll(event.target.checked);
    };

    const handleLivroChange = (event) => {
        const livro = livros.find((livro) => {
            return livro.codLivro === event.target.value;
        });
        setTdp({
            ...tdp,
            livro: livro
        });
    }

    return (
        <div>
            <CssBaseline />
            <Container className={classes.paper} component={Paper} maxWidth="sm">
                <Typography className={classes.title} variant="body1">
                    Alterar Livro
                </Typography>
                <form onSubmit={saveLivro}>
                    <TextField
                        variant="outlined"
                        size='small'
                        margin="normal"
                        fullWidth
                        autoFocus
                        label="Turma"
                        name="turma"
                        value={tdp.turma.descricao || ''}
                        slotProps={{
                            input: {
                                readOnly: true,
                            }
                        }}
                    />
                    <TextField
                        variant="outlined"
                        margin="normal"
                        fullWidth
                        autoFocus
                        size='small'
                        label="Disciplina"
                        name="disciplina"
                        value={tdp.disciplina.descricao || ''}
                        slotProps={{
                            input: {
                                readOnly: true,
                            }
                        }}
                    />
                    <FormControlLabel
                        control={
                            <Switch
                                checked={isLivrosAll ? true : false}
                                onChange={handleSwitchChange('ativo')}
                                value={isLivrosAll}
                            />
                        }
                        label="Todos os livros"
                    />
                    <FormControl required fullWidth className={classes.formControl}>
                        <InputLabel id="livro-label">Livro</InputLabel>
                        <Select
                            labelId="livro-label"
                            id="livro-select"
                            value={tdp.livro ? tdp.livro.codLivro : ''}
                            onChange={handleLivroChange}
                        >
                            {livros.map((livro, index) => (
                                <MenuItem key={index} value={livro.codLivro}>{livro.descricao}</MenuItem>
                            ))}

                        </Select>
                    </FormControl>
                    <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        className={classes.submit}>
                        Salvar
                    </Button>
                </form>
            </Container>
        </div>
    );
}